enum MeasureType {
  Count = 0,
  Passersby = 6,
  Visitor = 13,
  Occupancy = 18,
}

export default MeasureType;
